import GeometryBase from "./geo-base";

class GeometryTetrahedron extends GeometryBase {
    constructor(canvasSize) {

        GeometryTetrahedron.pairs = GeometryTetrahedron.pairs || [
            [
                new THREE.Line3(new THREE.Vector3(0.0, 0.0), new THREE.Vector3(0.5, 1.0)),
                new THREE.Line3(new THREE.Vector3(1.0, 0.0), new THREE.Vector3(0.5, 1.0))
            ]
        ];

        GeometryTetrahedron.editable = [false, true, true, true];

        GeometryTetrahedron.indices = GeometryTetrahedron.indices || new Array(
            [0, 1, 2],
            [1, 0, 3],
            [2, 1, 3],
            [0, 2, 3]
        );

        GeometryTetrahedron.additionalPairs = GeometryTetrahedron.additionalPairs || [
            new THREE.Line3(new THREE.Vector3(0, 0), new THREE.Vector3(1, 0))
        ];

        const unit = 1 / ((Math.sqrt(8 / 9)) * 2);

        GeometryTetrahedron.vertices = GeometryTetrahedron.vertices || new Array(
            new THREE.Vector3(Math.sqrt(8 / 9), -1 / 2, 0).multiplyScalar(unit),
            new THREE.Vector3(-Math.sqrt(2 / 9), -1 / 2, Math.sqrt(2 / 3)).multiplyScalar(unit),
            new THREE.Vector3(-Math.sqrt(2 / 9), -1 / 2, -Math.sqrt(2 / 3)).multiplyScalar(unit),
            new THREE.Vector3(0, 1 - 1 / 6, 0).multiplyScalar(unit)
        );

        GeometryTetrahedron.attrIndices = GeometryTetrahedron.attrIndices || new THREE.Uint8BufferAttribute([0, 1, 2], 1);
        GeometryTetrahedron.attrUv = GeometryTetrahedron.attrUv || new THREE.Float32BufferAttribute([
            0.0, 0.0,
            1.0, 0.0,
            0.5, 1.0
        ], 2);

        super(canvasSize);
    }
}

export default GeometryTetrahedron;
export { GeometryTetrahedron };